"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtcConnection = void 0;
class RtcConnection {
}
exports.RtcConnection = RtcConnection;
